export enum FilterSelectType {
  TENANTS = "tenants",
  GUARDIANS = "guardians",
  TESTED_PERSON_OCCUPATION = 'tested_person_occupation'
}